import Select from 'react-select'
import { twMerge } from 'tailwind-merge'

type TComboBoxPlatformProps = {
  placeholder: string
  value: { label: string; value: string }[]
  onChange: (value: readonly unknown[]) => void
  message?: string
  isInvalid?: boolean
}

export function ComboBoxPlatform({
  placeholder,
  value,
  onChange,
  isInvalid,
}: TComboBoxPlatformProps) {
  return (
    <Select
      noOptionsMessage={() => 'Sem opções encontradas'}
      placeholder={placeholder}
      isMulti
      isSearchable
      options={[
        {
          label: 'Plataforma',
          value: 'platform',
        },
        {
          label: 'E-mail',
          value: 'email',
        },
      ]}
      value={value}
      onFocus={(e) => e.stopPropagation()}
      onChange={onChange}
      classNames={{
        container: () => twMerge('!w-full '),
        control: ({ isFocused }) =>
          twMerge(
            '!bg-gray-800 !rounded-lg',
            isFocused && '!border-gray-800 !shadow-none',
            isInvalid &&
              '!border !border-danger-500 !shadow-sm !shadow-danger-500',
            !isInvalid && '!border-none',
          ),
        input: () => twMerge('!text-gray-400 h-8'),
        menuList: () => twMerge('!bg-gray-800 !max-h-60'),
        option: ({ isFocused, isSelected }) =>
          twMerge(
            '!text-gray-400',
            isFocused && '!bg-gray-700',
            isSelected && '!bg-gray-600',
          ),
        multiValue: () =>
          twMerge('!bg-transparent !border border-gray-400 !rounded-full px-2'),
        multiValueLabel: () => twMerge('!text-gray-400 !font-outfit'),
        multiValueRemove: () =>
          twMerge(
            '!text-gray-400 !font-outfit !hover:bg-gray-400 remove-multi-value-button',
          ),
        indicatorsContainer: () => twMerge('!text-gray-400 cursor-pointer'),
      }}
    />
  )
}
